export default "__VITE_ASSET__De2ClVZa__"